import React, { useState, useEffect, useMemo } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import CookieBanner from './components/CookieBanner';
import { AuthProvider } from './contexts/AuthContext';
import { getDomainConfig } from './utils/domainConfig';
import { 
  mainRoutes, 
  adminRoutes, 
  luxotticaRoutes, 
  iconicRoutes,
  authRoutes,
  iconicAuthRoutes,
  luxotticaAuthRoutes
} from './routes';

// Map route types to route arrays
const routeMap = {
  main: mainRoutes,
  admin: adminRoutes,
  luxottica: luxotticaRoutes,
  iconic: iconicRoutes,
  auth: authRoutes,
  iconicAuth: iconicAuthRoutes,
  luxotticaAuth: luxotticaAuthRoutes
};

// Wrapper component to use Router hooks
const AppContent = () => {
  const location = useLocation();
  const config = useMemo(() => getDomainConfig(), []);

  // Debug: log the active routes
  useEffect(() => {
    console.log('🔧 Config:', config);
    console.log('🔧 Config routes:', config.routes);
    console.log('🔧 Route map:', routeMap);
    
    const activeRoutes = config.routes.flatMap(routeType => {
      console.log(`🔧 Looking for routeType: ${routeType}`, routeMap[routeType]);
      return routeMap[routeType] || [];
    });
    
    console.log('🔧 Active routes:', activeRoutes);
  }, [config]);

  useEffect(() => {
    // Only set up observer on home page
    if (location.pathname !== '/') {
      return;
    }
    
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const heading = document.getElementById('latest-projects-heading');
          if (heading) {
            if (entry.isIntersecting) {
              heading.textContent = 'other projects';
            } else {
              heading.textContent = 'projects';
            }
          }
        });
      },
      {
        threshold: 0.5,
        rootMargin: '0px'
      }
    );
    
    const heading = document.getElementById('latest-projects-heading');
    if (heading) {
      observer.observe(heading);
    }
    
    return () => {
      if (heading) {
        observer.unobserve(heading);
      }
    };
  }, [location.pathname]);
  
  // Get only the routes for the current domain/port
  const activeRoutes = useMemo(() => 
    config.routes.flatMap(routeType => routeMap[routeType] || []),
    [config.routes]
  );
  
  return (
    <div className="App relative">
      <main>
        <Routes>
          {activeRoutes.map((route, index) => (
            <Route 
              key={`${config.name}-${index}`} 
              path={route.path} 
              element={route.element} 
            />
          ))}
        </Routes>
      </main>
      <CookieBanner />
    </div>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;